import EnumType from "./EnumType.js";

// Mirrors AEM.Geo.Business.MRMRResourceType (labels: i18n "MRMRResourceType.n").
const values = {
  PotentialMineral: 0,
  Inferred: 1,
  Indicated: 2,
  Measured: 3,
  Probable: 4,
  Proven: 5
};

export default EnumType.generate(values, "MRMRResourceType.");
